<div class="alert-modal">
	<button class="close-x" aria-label="Close" (click)="close()">×</button>
	<div class="alert-body">
		<h1 class="alert-title">{{ title }}</h1>
		<div class="alert-message" [innerHTML]="message"></div>
		<div class="alert-actions" *ngIf="primaryButtonText">
			<button class="primary" (click)="primaryAction()">{{ primaryButtonText }}</button>
		</div>
	</div>
</div>
